//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { selectCostList,selectCostListNumb,selectCostDetail,deleteCost,deleteDIDI,FILE_URL } from '@/api/rem/cost/cost';
import SlipDel from 'vue-slip-delete'
  import {guid,formatTime} from '@/common/common'

import promise from '@/axios/promise'
import {DORM,JPT_URL,BASIC} from "@/config/constant"
var page=1;
var limit=10;
var didi=''
var status='';
export default{
  components: {
    SlipDel
  },
  filters: {
    numFilter(value) {
    // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(2);
      // num.toFixed(2)获取的是字符串
      return realVal
    },
    dateFilter(value){
      return value.substring(0,value.length-2)
    }
  },
  data(){
    return{
      num: 10,
      didiNum:10,
      refreshing: false,
      loading: false,
      text: 'List',
      checkbox:false,
      dataList:[],
      file_URL:'',
      active1:'0'
    }
  },
  created(){
    page=1;
    limit=10;
    status=''
    var pageLimit={'page':page,'limit':limit,'status':status}
    selectCostList(pageLimit).then(response =>{
      console.log(response);
      this.dataList=response.data;
    })
    promise({
      url:DORM+"/expense/selectDictionType",
      method:"get",
      async:false,
      params:{type:"fileUrl"}
    }).then(res=>{
        console.log(res);
        this.file_URL=res[0].dicCode
    });

  },
  methods:{
    changeStatus(){
       if(this.active1==0){
          // this.statusChange('待审批');
          this.costListSelect('')
      }else if(this.active1==1){
        // this.statusChange('已通过');
        this.costListSelect('未报销')

      }else if(this.active1==2){
        // this.statusChange('被驳回');
        this.costListSelect('已报销')

      }
    },
    callBack(){
      this.$router.push({path:'/'});
    },
    //费用编号检索
    costNumbSelect(){
      var costNumb = document.getElementById('costNumb').value;
      console.log(costNumb)
      var data = {'costNumb':costNumb,'status':status,'DIDI':didi}
      selectCostListNumb(data).then(response =>{
        this.dataList=response.data;
      })
    },//清除费用编号
    clearCostNumb(){
      document.getElementById('costNumb').value='';
      var costNumb = document.getElementById('costNumb').value;
      console.log(costNumb)
      var data = {'costNumb':costNumb,'status':status,'DIDI':didi}
      selectCostListNumb(data).then(response =>{
        this.dataList=response.data;
      })
    },//跳转详情
    costListClick(infoId){
      var fid={'Fid':infoId}
      selectCostDetail(fid).then(response =>{
        if(response.mainId !='' && response.mainId !=null){
          this.$router.push({ path: '/seeCost',query:{costData:response}})
        }else{
          if(response.costType=='滴滴'){
            this.$router.push({ path: '/seeCost',query:{costData:response}})
          }else{
            this.$router.push({ path: '/costDetail',query:{costData:response}})
          }

        }

      })
    },
    createCost(){
        this.$router.push({ path: '/createCost'})
    },
    refresh () {
          debugger;
          this.refreshing = true;
          this.$refs.container.scrollTop = 0;
          this.refreshing = false;
          // setTimeout(() => {
          //   this.refreshing = false;
          //   var pageLimit={'page':page,'limit':limit}
          //   selectAxpeAccolist(pageLimit).then(response =>{
          //     if(response.data.length!='0'){
          //       this.dataList.push(response.data)
          //     }
          //   })
          // }, 1000)
      },
      load () {
        page++;
         this.loading = true;
         setTimeout(() => {
            this.loading = false;
            var pageLimit={'page':page,'limit':limit,'DIDI':didi,'status':status}
            selectCostList(pageLimit).then(response =>{
              // console.log(response);
              if(response.data.length!='0'){
                for(var i=0;i<response.data.length;i++){
                  this.dataList.push(response.data[i])
                }
              }
            })
        }, 0)
      },//全部
      serchAll(event){
        var Button = document.getElementsByClassName('ButtonTran');
        console.log(Button.length);
        if(Button.length !=0){
          Button[0].className='serchButton';
        }
        event.srcElement.className='ButtonTran';
         page=1;
        limit=10;
        status='';
        didi='';
        var pageLimit={'page':page,'limit':limit}
        selectCostList(pageLimit).then(response =>{
          console.log(response);
          this.dataList=response.data;
        })
      },//未报销
      beReim(event){
        var Button = document.getElementsByClassName('ButtonTran');
        console.log(Button);
        if(Button.length !=0){
          Button[0].className='serchButton';
        }
        event.srcElement.className='ButtonTran';
        page=1;
        limit=10;
        status='未报销'
        var pageLimit={'page':page,'limit':limit,'status':status,'DIDI':didi}
        selectCostList(pageLimit).then(response =>{
          console.log(response);
          this.dataList=response.data;
        })
      },//已报销
      endReim(event){
        var Button = document.getElementsByClassName('ButtonTran');
        console.log(Button);
        if(Button.length !=0){
          Button[0].className='serchButton';
        }
        event.srcElement.className='ButtonTran';
        page=1;
        limit=10;
        status='已报销'
        var pageLimit={'page':page,'limit':limit,'status':status,'DIDI':didi}
        selectCostList(pageLimit).then(response =>{
          console.log(response);
          this.dataList=response.data;
        })
      },
      costListSelect(type){
        page=1;
        limit=10;
        status=type
        var pageLimit={'page':page,'limit':limit,'status':status,'DIDI':didi}
        selectCostList(pageLimit).then(response =>{
          console.log(response);
          this.dataList=response.data;
        })
      },
      //过滤滴滴
      selectDidi(){
        if(this.checkbox==true){
          didi='滴滴'
          page=1;
          limit=10;
          var pageLimit={'page':page,'limit':limit,'DIDI':didi,'status':status}
          selectCostList(pageLimit).then(response =>{
            console.log(response);
            this.dataList=response.data;
          })
        }else if(this.checkbox==false){
          didi=''
          page=1;
          limit=10;
          var pageLimit={'page':page,'limit':limit,'DIDI':didi,'status':status}
          selectCostList(pageLimit).then(response =>{
            console.log(response);
            this.dataList=response.data;
          })
        }
      },
      del(cost,index) {


        // 删除回调
        if(cost.mainId==null){

          this.$confirm('确定要删除？', '提示', {
            type: 'warning'
          }).then(({ result }) => {
          	if(result == true){
          		 if(cost.costType=='滴滴'){

              var fid={'fid':cost.infoFid}
              deleteDIDI(fid).then(res=>{
                console.log(res)
                this.dataList.splice(index,1)
              })
              }else{
                var fid={'fid':cost.infoFid}
                deleteCost(fid).then(res=>{
                  console.log(res)
                  this.dataList.splice(index,1)
                })
              }
          	}

          });
        }else{
          //不可删除
        }

      },
      //滑动
      slipOpen(vm) {
        // 无需手动关闭
      },
  }
}



// WEBPACK FOOTER //
// ./src/components/costList.vue